import React from "react";
import * as Styles from "../../../../../common-deprecated/styles/v2/toyota/custom/SelectPane";
import { useCompareV2Selector } from "../../../redux/store";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import { CompareV2Label } from "../../../utils/labels";
import { isRTL } from "../../../../../common-deprecated/settings/utils/commonSettingUtils";
import type { ModelGradeBodyTypeIdsType } from "../../../../../common-deprecated/features/compare/utils/newCarCompareTypes";
import { getGradeConfigurations } from "../../../utils/utils";

type ConfigurationPanelPropsType = {
    setSelectedCar: (car: ModelGradeBodyTypeIdsType) => void;
    selectedCar: ModelGradeBodyTypeIdsType;
    clearSelection: () => void;
};

const ConfigurationPanel = (props: ConfigurationPanelPropsType): JSX.Element => {
    const { selectedCar, setSelectedCar, clearSelection } = props;

    const availableCarsData = useCompareV2Selector(({ newCarCompare }) => newCarCompare.available);
    const availableCongifurationIds = useCompareV2Selector(
        ({ newCarCompare }) => newCarCompare.filteredCarList?.map((filteredCar) => filteredCar.configurationId) || [],
    );
    const settings = useCompareV2Selector((state) => state.commonSettings);
    const selectedConfigurations = useCompareV2Selector(({ newCarCompare }) =>
        newCarCompare.grades.map(({ configuration }) => configuration?.id).filter(Boolean),
    );
    const model = availableCarsData.find((m) => m.modelCode === selectedCar.model);

    // The grades and submodels are flattened here so it will be easier to map through them. Toyota doesn't need seperate submodels
    const availableConfigurations = model
        ? getGradeConfigurations(model, selectedConfigurations, availableCongifurationIds)
        : [];

    return (
        <Styles.Panel id={`${selectedCar.model}-pane`} aria-labelledby={`${selectedCar.model}-header`}>
            {model?.modelName && (
                <Styles.Header onClick={clearSelection}>
                    <Styles.HeaderButton>
                        <IconWrapper iconColor="primaryBlack">
                            <Icon variant={isRTL(settings) ? "arrowRight" : "arrowLeft"} />
                        </IconWrapper>
                        <CompareV2Label label="compareSelectBack" />
                    </Styles.HeaderButton>
                    <Styles.HeaderLabel>{model.modelName}</Styles.HeaderLabel>
                </Styles.Header>
            )}
            <Styles.PanelContent>
                <Styles.PanelScroll>
                    {availableConfigurations &&
                        availableConfigurations.map(
                            ({
                                gradeId,
                                bodyTypeId,
                                gradeName,
                                bodyTypeName,
                                subModelId,
                                subModelName,
                                configurationId,
                                packs,
                            }) => (
                                /* Improvement possible to change the next focus on the confirm button when car is selected + TAB */
                                <Styles.PanelItem
                                    key={gradeId + bodyTypeId + subModelName + configurationId}
                                    selected={selectedCar.configurationId === configurationId}
                                    onClick={() =>
                                        setSelectedCar({
                                            ...selectedCar,
                                            gradeId,
                                            bodyTypeId,
                                            submodelId: subModelId,
                                            configurationId,
                                        })
                                    }
                                    aria-pressed={
                                        selectedCar.gradeId === gradeId && selectedCar.bodyTypeId === bodyTypeId
                                    }
                                    configuration
                                >
                                    {`${subModelName || ""} ${gradeName} ${bodyTypeName}`.trim()}
                                    {packs?.map((pack) => (
                                        <Styles.PackItem key={pack.id}>{pack.name}</Styles.PackItem>
                                    ))}
                                </Styles.PanelItem>
                            ),
                        )}
                </Styles.PanelScroll>
            </Styles.PanelContent>
        </Styles.Panel>
    );
};

export default ConfigurationPanel;
